import React from 'react';

const approvedIcon = 
    <img src="/images/admin/global/status/success.svg" width="16px" alt="" />
export default approvedIcon;